/* istanbul ignore file */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { App, KHFileInfo, Project, ProjectNote } from '../../models';
import { environment } from './../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ProjectNotesDataService extends HttpBaseService {

    private route = environment.api + 'apps/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    createProjectNote(app: App, project: Project, projectNote: ProjectNote): Observable<ProjectNote> {
        const url = `${this.route}${app.id}/projects/${project.id}/project-notes`;
        return this.httpPost(url, projectNote);
    }

    updateProjectNote(app: App, projectNote: ProjectNote, updatedProjectNote: ProjectNote): Observable<ProjectNote> {
        const url = `${this.route}${app.id}/projects/${projectNote.projectId}/project-notes/${projectNote.id}`;
        return this.httpPut(url, updatedProjectNote);
    }

    deleteProjectNote(app: App, projectNote: ProjectNote): Observable<null> {
        const url = `${this.route}${app.id}/projects/${projectNote.projectId}/project-notes/${projectNote.id}`;
        return this.httpDelete(url);
    }

    getProjectNotesByProjectId(app: App, project: Project): Observable<ProjectNote[]> {
        const url = `${this.route}${app.id}/projects/${project.id}/project-notes`;
        return this.httpGet(url);
    }

    getSummaryProjectProjectNotes(app: App, project: Project): Observable<ProjectNote[]> {
        const url = `${this.route}${app.id}/summary-projects/${project.id}/project-notes`;
        return this.httpGet(url);
    }

    uploadFile(app: App, projectNote: ProjectNote, file: FormData): Observable<ProjectNote> {
        const url = `${this.route}${app.id}/projects/${projectNote.projectId}/project-notes/${projectNote.id}/container/${app['fileContainers'].private.name}`;
        return this.httpPost(url, file);
    }

    deleteFile(app: App, projectNote: ProjectNote, file: KHFileInfo): Observable<ProjectNote> {
        const url = `${this.route}${app.id}/projects/${projectNote.projectId}/project-notes/${projectNote.id}/container/${app['fileContainers'].private.name}`;
        return this.httpDeleteWithBody(url, file);
    }
}
